import React from 'react';
import { Mail, Instagram, Facebook, Youtube, Twitter } from 'lucide-react';
import { podcastInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Quick Links',
      links: [
        { name: 'Home', href: '#home' },
        { name: 'Episodes', href: '#episodes' },
        { name: 'About', href: '#about' },
        { name: 'Subscribe', href: '#subscribe' }
      ]
    },
    {
      title: 'Listen',
      links: [
        { name: 'Spotify', href: '#' },
        { name: 'Apple Podcasts', href: '#' },
        { name: 'YouTube', href: '#' },
        { name: 'RSS Feed', href: '#' }
      ]
    },
    {
      title: 'Connect',
      links: [
        { name: 'Contact', href: '#' },
        { name: 'Newsletter', href: '#subscribe' },
        { name: 'Press Kit', href: '#' },
        { name: 'Partnerships', href: '#' }
      ]
    }
  ];

  const socialLinks = [
    { icon: Instagram, href: podcastInfo.host.social.instagram, label: 'Instagram' },
    { icon: Facebook, href: podcastInfo.host.social.facebook, label: 'Facebook' },
    { icon: Youtube, href: podcastInfo.host.social.youtube, label: 'YouTube' },
    { icon: Twitter, href: podcastInfo.host.social.twitter, label: 'Twitter' },
    { icon: Mail, href: 'mailto:info@noapologypodcast.com', label: 'Email' }
  ];

  return (
    <footer className="bg-black border-t border-purple-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={podcastInfo.branding.logoMic}
                alt="NO! APOLOGY Logo"
                className="h-12 w-12"
              />
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
                  {podcastInfo.title}
                </span>
                <span className="text-xs text-gray-500 tracking-wider">{podcastInfo.subtitle}</span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm">
              {podcastInfo.description}
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="inline-flex items-center justify-center w-10 h-10 bg-gray-900 border border-gray-800 rounded-full text-gray-400 hover:text-purple-400 hover:border-purple-500 transition-all duration-300 hover:scale-110"
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((column, index) => (
            <div key={index}>
              <h3 className="text-white font-bold mb-4">{column.title}</h3>
              <ul className="space-y-2">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-purple-400 transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} {podcastInfo.title}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
